import { isBoolean, isString as isLodashString } from 'lodash-es'
import { DataClass } from 'scrivito'

import { getReferenceDataClass } from './getDataClass'
import { Company } from '@/Data/Company/CompanyDataClass'
import { Person } from '@/Data/Person/PersonDataClass'
import { SchemaAttribute } from '@/Data/typesV2'
import { getDataItem } from '@/utils/getDataItem'
import { isString } from '@/utils/isString'

export const getReferenceDataItemFromDataClass = (
  dataClass: DataClass,
  referenceId?: string,
) => {
  if (isString(referenceId)) {
    if (dataClass.name() === 'Contact') {
      const contactReferencedDataItem = dataClass.get(referenceId)
      const isPersonDefined = isBoolean(
        contactReferencedDataItem?.get('isPerson'),
      )

      if (isPersonDefined) {
        const isPerson = contactReferencedDataItem?.get('isPerson')
        if (isPerson) {
          return getDataItem(Person, referenceId)
        } else {
          return getDataItem(Company, referenceId)
        }
      }
    } else {
      return getDataItem(dataClass, referenceId)
    }
  }
}

export const getReferenceDataItem = (
  attribute?: SchemaAttribute,
  attributeValue?: unknown,
) => {
  if (attribute?.type !== 'reference') return undefined
  const { referenceTo, referenceFilter } = attribute

  if (!isLodashString(attributeValue) || !referenceTo) return undefined
  const dataClass = getReferenceDataClass(referenceTo, referenceFilter)
  if (!dataClass) return undefined

  const reference = getReferenceDataItemFromDataClass(dataClass, attributeValue)
  return reference?.dataItem ?? undefined
}
